import { DatePicker } from "antd";
import React from "react";
import { IoIosArrowDown } from "react-icons/io";

const DateInput = ({ name, value, onChange }) => {
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="Date">Date</label>
      <div className="relative flex items-center">
        <DatePicker
          onChange={onChange}
          value={value}
          name={name}
          className="h-[50px] w-full rounded-[10px] border border-[#e5e7eb] hover:border-[#e5e7eb] focus:outline-none"
          // defaultValue={dayjs("10/05/2024", dateFormatList[0])}
          format={dateFormatList}
          suffixIcon={<IoIosArrowDown className="text-gray-500" size={24} />}
        />
      </div>
    </div>
  );
};

export default DateInput;
